import {
  Box,
  Typography,
  Button,
  Grid,
   Paper,
   Stack
} from "@mui/material";

import PersonIcon from "@mui/icons-material/Person";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";


import { FooterContacto } from "./FooterWhatsapp";


export const PanelContacto = ({
    trabajoRef,
    matriculaRef,
    admisionRef,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 5,
        borderRadius: "32px",
        overflow: "hidden",
        border: "1px solid #eff2f6",
        background: "#fff",
      }}
    >
      <Grid container spacing={4} ref={trabajoRef}>
        {/* Panel izquierdo */}
        <Grid size={{ xs: 12, md: 3 }}>
          <Box
            sx={{
              height: "100%",
              minHeight: 200,
              borderRadius: "26px",
              background:
                "#e1bcc4",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              px: 4,
              py: 6,
              color: "#fff",
              position: "relative",
              overflow: "hidden",

              "&::before": {
                content: '""',
                position: "absolute",
                width: 250,
                height: 250,
                borderRadius: "50%",
                background: "rgba(255,255,255,.08)",
                top: -80,
                right: -70,
              },

              "&::after": {
                content: '""',
                position: "absolute",
                width: 180,
                height: 180,
                borderRadius: "50%",
                background: "rgba(255,255,255,.05)",
                bottom: -60,
                left: -40,
              },
            }}
          >
            <Box
              sx={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                bgcolor: "rgba(255,255,255,.18)",
                backdropFilter: "blur(10px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 3,
                zIndex: 1,
              }}
            >
              <PersonIcon sx={{ fontSize: 40, color:'#561c33'
 }} />
            </Box>

            <Typography
             
              sx={{
                fontWeight: 700,
                mb: 1,
                  fontSize: '1.7rem',
                zIndex: 1,
                lineHeight:1.1,
                color:'#561c33'
              }}
            >
              ¿Quieres trabajar con nosotros?
            </Typography>

            <Typography
              sx={{
                fontSize: '0.9rem',
                color:"#443838"
              }}
            >
              Forma parte de nuestro equipo educativo 
            </Typography>
          </Box>
        </Grid>

        {/* Panel derecho */}
       <Grid size={{ xs: 12, md: 9 }}>
  <Box
    sx={{
      height: "100%",
      borderRadius: "26px",
   
      p: { sm: 0, md: 6 },
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    }}
  >
    {/* Badge */}
    <Box
      sx={{
        width: "fit-content",
        px: 2,
        py: 0.7,
        borderRadius: "30px",
        bgcolor: "#f99595",
        color: "#fff",
        fontWeight: 600,
        mb: 1,
      }}
    >
      Oportunidad Laboral
    </Box>

    {/* Título */}
    <Typography
      
      sx={{
        fontWeight: 700,
        color: "#561c33",
        mb: 1,
        fontSize:{xs:'1rem', sm:'1.1rem', md:'1.5rem'}
      }}
    >
      Forma parte de nuestro equipo
    </Typography>

    {/* Descripción */}
    <Typography
      sx={{
        color: "#5f6c7b",
         fontSize:{xs:'1rem', sm:'1.1rem', md:'0.9rem'},
        lineHeight: 1.4,

        mb:3,
      }}
    >
      En nuestro establecimiento buscamos personas comprometidas con la
      educación, la innovación y el desarrollo integral de nuestros estudiantes.
      Si deseas aportar con tu experiencia y vocación, nos encantaría conocer tu
      perfil.
    </Typography>

    {/* Beneficios */}
   
    {/* Botón */}
       <Button
       component="a"
  href="https://wa.me/56932385589"
  target="_blank"
  rel="noopener noreferrer"
      startIcon={<WhatsAppIcon />}
      variant="contained"
      sx={{
        mt:2,
        width: "fit-content",
        px: 3,
        py: 1,
        color:'#fff',
        borderRadius: "50px",
        bgcolor: "#561c33",
        textTransform: "none",
         fontSize:{xs:'0.86rem', sm:'0.7rem', md:'0.8rem'},
        fontWeight: 700,
       
        "&:hover": {
          bgcolor: "#e3effb",
          color:"#561c33"
        },
      }}
    >
      consulta matriculas por WhatsApp
    </Button>
  </Box>
</Grid>
      </Grid>
       <Box
    sx={{
      width: '100%',
      height: 2,
      borderRadius: 999,
      background: "#E5EEF7",
      mx: "auto",
      mt: 3,
      mb: 4,
    }}
  />
   <Grid container spacing={3}  ref={matriculaRef}>
    {/* ==================== MATRÍCULAS ==================== */}
    <Grid size={{ xs: 12, md: 3 }}>
      <Box
        sx={{
          height: "100%",
          p: 4,
          display:'flex', 
          alignItems:'center',
          justifyContent:'center',
           flexDirection:'column',
          borderRadius: "25px",
          background:
            "#e3effb",
          color: "#484a75",
        }}
      >
        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: "50%",
            bgcolor: "rgba(255, 255, 255, 0.34)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
         <SchoolOutlinedIcon sx={{ fontSize: 40, color: "#484a75" }} />
        </Box>

        <Typography sx={{
                fontWeight: 700,
                mb: 1,
                  fontSize: '1.7rem',
                zIndex: 1,
                lineHeight:1.1,
                textAlign:'center'
              }}>
          Matrículas 2026
        </Typography>

        <Typography sx={{
       
         fontSize:{xs:'1rem', sm:'1.1rem', md:'0.9rem'},
        lineHeight: 1.4,
            textAlign:'center',
        mb:3,
      }}>
          Información sobre el proceso de matrícula.
        </Typography>
      </Box>
    </Grid>

    {/* ==================== PROCESO ==================== */}
    <Grid size={{ xs: 12, md: 5 }}>
      <Box
        sx={{
          height: "100%",
          p:{sm:0, md:4},

       
  borderRight: {
    xs: "none",
    md: "1px solid #E5EEF7",
  },

        }}
      >
        <Typography
           sx={{
        fontWeight: 700,
        color: "#1d3557",
        mb: 1,
        fontSize:{xs:'1rem', sm:'1.1rem', md:'1.5rem'}
      }}
         
          
        >
          Proceso de Matrícula 2026
        </Typography>

        <Box  sx={{ pl: 2, m: 0 }}>
          <Box>
           <Typography
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontWeight: 700,
    color: "#1d3557",
    mb: 1,
    fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
  }}
>
  <CalendarMonthOutlinedIcon
    sx={{
      color: "#484a75",
      fontSize: 22,
    }}
  />
  Periodo oficial
</Typography>

<Typography
  sx={{
    fontWeight: 600,
    color: "#1d3557",
    mb: 3,
    p: 2,
    borderRadius: "15px",
    background: "#e3effb",
    fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
  }}
>
  Del 09 al 23 de diciembre de 2026
</Typography>

        
          </Box>
          <Box>
            <Typography
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontWeight: 700,
    color: "#1d3557",
    mb: 2,
    fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
  }}
>
  <AccessTimeOutlinedIcon
    sx={{
      color: "#484a75",
      fontSize: 22,
    }}
  />
  Horarios de atención
</Typography>
          <Grid container spacing={1}>
            <Grid size={{xs:12,sm:6}}>
               <Box
  sx={{
    color: "#1d3557",
    p: 2,
    borderRadius: "15px",
    background: "#e3effb",
  }}
>
  <Typography
    sx={{
      fontWeight: 700,
      color: "#484a75",
      mb: 2,
      fontSize: {
        xs: "0.75rem",
        sm: "0.85rem",
        md: "0.95rem",
      },
    }}
  >
    Lunes a jueves
  </Typography>

  <Box
    component="ul"
    sx={{
      pl: 2,
      m: 0,
      "& li": {
        mb: 1,
      },
    }}
  >
    <li>
      <Typography
        sx={{
          fontSize: {
            xs: "0.75rem",
            sm: "0.8rem",
            md: "0.9rem",
          },
        }}
      >
        08:30 a 13:30 hrs.
      </Typography>
    </li>

    <li>
      <Typography
        sx={{
          fontSize: {
            xs: "0.75rem",
            sm: "0.8rem",
            md: "0.9rem",
          },
        }}
      >
        14:30 a 16:30 hrs.
      </Typography>
    </li>
  </Box>
</Box>
            </Grid>
            <Grid size={{xs:12,sm:6}}>
              <Box
  sx={{
    color: "#1d3557",
    p: 2,
    minHeight:135,
    borderRadius: "15px",
    background: "#e3effb",
  }}
>
  <Typography
    sx={{
      fontWeight: 700,
      color: "#484a75",
      mb: 2,
      fontSize: {
        xs: "0.75rem",
        sm: "0.85rem",
        md: "0.95rem",
      },
    }}
  >
    Viernes
  </Typography>

  <Box
    component="ul"
    sx={{
      pl: 2,
      m: 0,
    }}
  >
    <li>
      <Typography
        sx={{
          fontSize: {
            xs: "0.75rem",
            sm: "0.8rem",
            md: "0.9rem",
          },
        }}
      >
        08:30 a 14:30 hrs.
      </Typography>
    </li>
  </Box>
</Box>
            </Grid>
            <Grid size={12}>
                <Button
                component="a"
  href="https://wa.me/56932385589"
  target="_blank"
  rel="noopener noreferrer"
      startIcon={<WhatsAppIcon />}
      variant="contained"
      sx={{
        mt:2,
        width: "fit-content",
        px: 3,
        py: 1,
        color:'#fff',
        borderRadius: "50px",
        bgcolor: "#484a75",
        textTransform: "none",
         fontSize:{xs:'0.86rem', sm:'0.7rem', md:'0.8rem'},
        fontWeight: 700,
        boxShadow: "0 12px 30px rgba(37, 141, 211, 0.3)",
        "&:hover": {
          bgcolor: "#e3effb",
          color:"#484a75"
        },
      }}
    >
      consulta matriculas por WhatsApp
    </Button>
            </Grid>
          </Grid>
        </Box>
        </Box>
      </Box>
    </Grid>

    {/* ==================== DOCUMENTOS ==================== */}
   <Grid size={{ xs: 12, md: 4 }}>
  <Box
    sx={{
      height: "100%",
      p: 4,
      borderRadius: "25px",
    }}
  >
    <Typography
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        fontWeight: 700,
        color: "#1d3557",
        mb: 3,
        fontSize: {
          xs: "0.9rem",
          sm: "1rem",
          md: "1.2rem",
        },
      }}
    >
      <DescriptionOutlinedIcon
        sx={{
          color: "#484a75",
          fontSize: 24,
        }}
      />

      Documentación requerida
    </Typography>

    <Stack spacing={2}>
      <Stack direction="row" spacing={1.5} alignItems="center">
        <CheckCircleRoundedIcon
          sx={{
            color: "#484a75",
            fontSize: 18,
            mt: "2px",
          }}
        />

        <Typography
          sx={{
            color: "#1d3557",
            fontSize: {
              xs: "0.85rem",
              sm: "0.95rem",
              md: "0.9rem",
            },
            lineHeight: 1,
          }}
        >
          Ficha de salud.
        </Typography>
      </Stack>

      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <CheckCircleRoundedIcon
          sx={{
            color: "#484a75",
            fontSize: 18,
            mt: "2px",
          }}
        />

        <Typography
          sx={{
            color: "#1d3557",
            fontSize: {
              xs: "0.85rem",
              sm: "0.95rem",
              md: "0.9rem",
            },
            lineHeight: 1,
          }}
        >
          Ficha de matrícula.
        </Typography>
      </Stack>

      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <CheckCircleRoundedIcon
          sx={{
            color: "#484a75",
            fontSize: 18,
            mt: "2px",
          }}
        />

        <Typography
           sx={{
            color: "#1d3557",
            fontSize: {
              xs: "0.85rem",
              sm: "0.95rem",
              md: "0.9rem",
            },
            lineHeight: 1,
          }}
        >
          Autorización para uso de imagen, video y audio.
        </Typography>
      </Stack>

      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <CheckCircleRoundedIcon
          sx={{
            color: "#484a75",
            fontSize: 18,
            mt: "2px",
          }}
        />

        <Typography
           sx={{
            color: "#1d3557",
            fontSize: {
              xs: "0.85rem",
              sm: "0.95rem",
              md: "0.9rem",
            },
            lineHeight: 1,
          }}
        >
          Adhesión a clases de religión.
        </Typography>
      </Stack>

      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <CheckCircleRoundedIcon
          sx={{
            color: "#484a75",
            fontSize: 18,
            mt: "2px",
          }}
        />

        <Typography
           sx={{
            color: "#1d3557",
            fontSize: {
              xs: "0.85rem",
              sm: "0.95rem",
              md: "0.9rem",
            },
            lineHeight: 1,
          }}
        >
          Certificado de nacimiento actualizado del estudiante.
        </Typography>
      </Stack>

      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <CheckCircleRoundedIcon
          sx={{
            color: "#484a75",
            fontSize: 18,
            mt: "2px",
          }}
        />

        <Typography
           sx={{
            color: "#1d3557",
            fontSize: {
              xs: "0.85rem",
              sm: "0.95rem",
              md: "0.9rem",
            },
            lineHeight: 1,
          }}
        >
          Fotocopia de la cédula de identidad del apoderado financiero.
        </Typography>
      </Stack>
    </Stack>
  </Box>
</Grid>
  </Grid>
    <Box
    sx={{
      width: '100%',
      height: 2,
      borderRadius: 999,
      background: "#E5EEF7",
      mx: "auto",
      mt: 3,
      mb: 4,
    }}
  />
  <Grid container spacing={3}  ref={admisionRef}>
  {/*================== IZQUIERDA ==================*/}
  <Grid size={{ xs: 12, md: 3 }}>
    <Box
      sx={{
        height: "100%",
        bgcolor: "#e1bcc4a0",
        borderRadius: "25px",
        p: 4,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      
        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: "50%",
            bgcolor: "rgba(255, 255, 255, 0.34)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
      
        <AssignmentTurnedInOutlinedIcon
          sx={{
            color: "#561c33",
            fontSize: 40,
          }}
        />
      </Box>

      <Typography
        sx={{
          fontWeight: 700,
          color: "#561c33",
          fontSize: {
            xs: "1.4rem",
            md: "1.7rem",
          },
        }}
      >
        Admisión
      </Typography>

      <Typography
        sx={{
          mt: 1,
          fontWeight:500,
          color: "#555",
          lineHeight: 1.3,
           fontSize: {
            xs: "0.9rem",
            md: "1rem",
          },
        }}
      >
        Requisitos y proceso de admisión.
      </Typography>
    </Box>
  </Grid>

  {/*================== CENTRO ==================*/}
  <Grid size={{ xs: 12, md: 5 }}>
    <Box sx={{ height: "100%" }}>
      <Typography
        sx={{
          color: "#561c33",
          fontWeight: 700,
          fontSize: {
            xs:"1rem",
            sm: "1.4rem",
            md: "2rem",
          },
        }}
      >
        Proceso de Admisión
      </Typography>

      <Typography
       sx={{
        color: "#5f6c7b",
         fontSize:{xs:'1rem', sm:'1.1rem', md:'0.9rem'},
        lineHeight: 1.4,

        mb:3,
      }}
      >
        Si deseas formar parte de nuestra comunidad educativa,
        estaremos encantados de orientarte durante todo el proceso
        de admisión.
      </Typography>

      <Typography
        sx={{
          mt: 3,
          mb: 2,
          color: "#561c33",
          fontWeight: 600,
        }}
      >
        Nuestro equipo responderá tus consultas sobre:
      </Typography>

      <Stack spacing={2}>
        {[
          "Requisitos de ingreso.",
          "Vacantes disponibles.",
          "Documentación requerida.",
          "Fechas importantes.",
          "Proceso de postulación.",
        ].map((item) => (
          <Stack
            key={item}
            direction="row"
            spacing={1.1}
            alignItems="center"
          >
            <CheckCircleOutlineRoundedIcon
              sx={{
                color: "#561c33",
                fontSize: 20,
              }}
            />

            <Typography sx={{
            color: "#555",
            fontSize: {
              xs: "0.85rem",
              sm: "0.95rem",
              md: "0.9rem",
            },
            lineHeight: 1,
          }}>
              {item}
            </Typography>
          </Stack>
        ))}
      </Stack>

      
    </Box>
  </Grid>

  {/*================== DERECHA ==================*/}
  <Grid size={{ xs: 12, md: 4 }}>
    <Box
      sx={{
        border: "1px solid #f0d7d7",
        borderRadius: "20px",
        p: 3,
        bgcolor: "#e1bcc4a0",
      }}
    >
      <Stack direction="row" spacing={2}>
        <LanguageRoundedIcon
          sx={{
            color: "#561c33",
            fontSize: 40,
          }}
        />

        <Box>
          
          <Typography
            sx={{
              color: "#555",
              fontSize: "0.9rem",
              lineHeight: 1.7,
              fontWeight:500
            }}
          >
            Además, si necesitas  obtener  tu  Clave única, puedes hacerlo desde el sitio oficial del Gobierno de Chile.
          </Typography>
        </Box>
      </Stack>

      <Button
        fullWidth
        endIcon={<OpenInNewRoundedIcon />}
        variant="outlined"
        sx={{
          mt: 3,
          background:'#fff',
          borderRadius: "12px",
          textTransform: "none",
          borderColor: "#561c33",
          color: "#561c33",
          py: 1.5,
          fontWeight: 600,
          fontSize: {
      xs: "0.75rem",
      sm: "0.8rem",
      md: "0.95rem",
    },

          "&:hover": {
            borderColor: "#561c33",
            bgcolor: "#f6f7fc",
          },
        }}
      >
         https://claveunica.gob.cl/
      </Button>

      
    </Box>
     <Button
     component="a"
  href="https://wa.me/56932385589"
  target="_blank"
  rel="noopener noreferrer"
        startIcon={<WhatsAppIcon />}
        variant="contained"
        sx={{
          mt: 5,
          bgcolor: "#f37070",
          borderRadius: "50px",
          px: 4,
          py: 1.5,
          textTransform: "none",
          fontWeight: 700,
         

          "&:hover": {
            bgcolor: "#f37070",
          },
        }}
      >
        Consultar admisión por WhatsApp
      </Button>

      <Button
              
              href="/admision"
              sx={{
                mt:2,
                ml: 1,
                px: 4.5,
                py: 1,
                borderRadius: "22px",
                fontWeight: 700,
                fontSize: "0.85rem",
                color: "#ffffff",
                backgroundColor: "#8f1515",
                boxShadow: "0 4px 12px rgba(143,21,21,0.25)",
                transition: "all 0.3s ease",

                "&:hover": {
                  backgroundColor: "#561c33",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 16px rgba(86,28,51,0.35)",
                },
              }}
            >
              ADMISIÓN
            </Button>
  </Grid>
</Grid>

<FooterContacto/>
    </Paper>
  );
};